import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { WhiteLabelConfig } from './types'

export const fetchConfig = (domain: string) => {
  return apiClient.get<WhiteLabelConfig>(endpoints.currentConfig(), { domain })
}
